export const ADVERTISEMENT_DATA = 'advertisement_data'

export const MY_PROFILE_COMPANY_KEY = 'myProfileCompany'

export const MY_PROFILE_FACTORY_KEY = 'myProfileFactory'

export const MY_PROFILE_FREELANCER_KEY = 'myProfileFreelancer'
